// Lib
import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import PwaOnly from '../../../pwaApp/PwaOnly';
import PwaTitleBarStyle from './PwaTitleBarStyle';
import AccountUtil from './account/AccountUtil';
import ReferUtil from './refer/ReferUtil';
import HelpUtil from './help/HelpUtil';
import ElementSearchUtil from './elementSearch/ElementSearchUtil';
import BoardSearchUtil from './boardSearch/BoardSearchUtil';
import NotificationsUtil from './notifications/NotificationsUtil';
import QuickNotesUtil from './quickNotes/QuickNotesUtil';
import AppHeaderBreadcrumbs from './AppHeaderBreadcrumbs';
import UndoRedoUtil from './undoRedo/UndoRedoUtil';
import Measure from '../../../../node_module_clones/react-measure/src/Measure';

// Styles
import './WorkspaceToolsHeader.scss';

const RemainingHeaderRightTools = ({
    currentUser,
    utilPopupOpened,
    createShortcutCard,
    isBoardSearchEnabled,
    pageTitle,
    currentBoardId,
}) => {
    return (
        <>
            <QuickNotesUtil
                currentUser={currentUser}
                createShortcutCard={createShortcutCard}
                tooltipEnabled={!utilPopupOpened}
            />
            <HelpUtil currentUser={currentUser} tooltipEnabled={!utilPopupOpened} />

            {isBoardSearchEnabled ? (
                <BoardSearchUtil
                    currentUser={currentUser}
                    currentBoardId={currentBoardId}
                    tooltipEnabled={!utilPopupOpened}
                />
            ) : (
                <ElementSearchUtil currentUser={currentUser} tooltipEnabled={!utilPopupOpened} />
            )}

            <NotificationsUtil pageTitle={pageTitle} currentUser={currentUser} tooltipEnabled={!utilPopupOpened} />
            <AccountUtil currentUser={currentUser} tooltipEnabled={!utilPopupOpened} />
        </>
    );
};

RemainingHeaderRightTools.propTypes = {
    currentUser: PropTypes.object,
    utilPopupOpened: PropTypes.bool,
    createShortcutCard: PropTypes.func,
    isBoardSearchEnabled: PropTypes.bool,
    pageTitle: PropTypes.string,
    currentBoardId: PropTypes.string,
};

const WorkspaceToolsHeader = ({
    currentUser,
    currentBoardId,
    rootBoardId,
    isLoadingBreadcrumbs,
    breadcrumbObj,
    utilPopupOpened,
    createShortcutCard,
    pageTitle,
    isPresentationMode,
    isBoardSearchEnabled,
    isUndoRedoButtonsSettingEnabled,
    isSidebarProtypeEnabled,
}) => {
    const [totalHeaderWidth, setTotalHeaderWidth] = useState(0);
    const [utilHeaderWidth, setUtilHeaderWidth] = useState(0);

    const availableWidth = totalHeaderWidth - utilHeaderWidth;
    return (
        <Measure whitelist={['width']} onMeasure={({ width }) => setTotalHeaderWidth(width)}>
            <div className="WorkspaceToolsHeader header-tools">
                <PwaOnly>
                    <PwaTitleBarStyle />
                </PwaOnly>
                <div className="header-left">
                    {!isSidebarProtypeEnabled && (
                        <AppHeaderBreadcrumbs
                            breadcrumbObj={breadcrumbObj}
                            currentBoardId={currentBoardId}
                            rootBoardId={rootBoardId}
                            availableWidth={availableWidth}
                            isLoadingBreadcrumbs={isLoadingBreadcrumbs}
                        />
                    )}
                </div>
                <Measure
                    whitelist={['width']}
                    onMeasure={({ width }) => setUtilHeaderWidth(width)}
                    shouldMeasure={!isPresentationMode}
                >
                    <div className="header-right">
                        <ReferUtil currentUser={currentUser} />
                        {isUndoRedoButtonsSettingEnabled && (
                            <>
                                <UndoRedoUtil currentUser={currentUser} tooltipEnabled={!utilPopupOpened} />

                                {!isSidebarProtypeEnabled && <div className="HeaderUtil divider" />}
                            </>
                        )}

                        {!isSidebarProtypeEnabled && (
                            <RemainingHeaderRightTools
                                currentUser={currentUser}
                                utilPopupOpened={utilPopupOpened}
                                createShortcutCard={createShortcutCard}
                                isBoardSearchEnabled={isBoardSearchEnabled}
                                pageTitle={pageTitle}
                                currentBoardId={currentBoardId}
                            />
                        )}
                    </div>
                </Measure>
            </div>
        </Measure>
    );
};

WorkspaceToolsHeader.propTypes = {
    currentBoardId: PropTypes.string,
    rootBoardId: PropTypes.string,
    pageTitle: PropTypes.string,
    isLoadingBreadcrumbs: PropTypes.bool,
    isPresentationMode: PropTypes.bool,
    isBoardSearchEnabled: PropTypes.bool,
    utilPopupOpened: PropTypes.bool,
    isUndoRedoButtonsSettingEnabled: PropTypes.bool,
    isSidebarProtypeEnabled: PropTypes.bool,
    currentUser: PropTypes.object,
    breadcrumbObj: PropTypes.object,
    createShortcutCard: PropTypes.func,
};

export default WorkspaceToolsHeader;
